import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ListChecks, BookOpen, MessageSquareHeart, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "../lib/auth";

const Item = ({ active, label, Icon, onClick, testid }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className={`flex flex-col items-center justify-center gap-0.5 px-1 py-2 transition-colors flex-1 min-w-0 ${
      active ? "text-[#8BA38E]" : "text-[#8A9C91]"
    }`}
  >
    <Icon size={18} strokeWidth={1.5} />
    <span className="text-[10px] font-medium tracking-wide leading-none mt-1">{label}</span>
  </button>
);

export const BottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { user } = useAuth();
  if (!user) return null;
  const isPractitioner = user.role === "therapist" || user.role === "coach";

  const tabs = isPractitioner
    ? [
        { path: "/dashboard", label: "Home", icon: Home, testid: "nav-home" },
        { path: "/sessions", label: "Sessions", icon: ListChecks, testid: "nav-sessions" },
        { path: "/journal", label: "Journal", icon: BookOpen, testid: "nav-journal" },
        { path: "/feedback", label: "Feedback", icon: MessageSquareHeart, testid: "nav-feedback" },
        { path: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
      ]
    : [
        { path: "/dashboard", label: "Home", icon: Home, testid: "nav-home" },
        { path: "/sessions", label: "Sessions", icon: ListChecks, testid: "nav-sessions" },
        { path: "/journal", label: "Journal", icon: BookOpen, testid: "nav-journal" },
        { path: "/feedback", label: "Feedback", icon: MessageSquareHeart, testid: "nav-feedback" },
        { path: "/settings", label: "Settings", icon: SettingsIcon, testid: "nav-settings" },
      ];

  return (
    <nav
      className="fixed bottom-6 left-3 right-3 h-16 bg-white/55 backdrop-blur-xl border border-white/40 shadow-[0_8px_32px_rgba(0,0,0,0.06)] rounded-[20px] flex justify-around items-center px-2 z-50 max-w-xl mx-auto"
      data-testid="bottom-nav"
    >
      {tabs.map((t) => (
        <Item
          key={t.path}
          active={pathname === t.path || (t.path !== "/dashboard" && pathname.startsWith(t.path))}
          label={t.label}
          Icon={t.icon}
          onClick={() => navigate(t.path)}
          testid={t.testid}
        />
      ))}
    </nav>
  );
};

export default BottomNav;
